<template>
    <div>
        <Modal
        class-name="vertical-center-modal"
        :value="showSetModel && (DataType==13)"
        :title="$t('edit')"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'700px'}">
        
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80" >
             <!-- 数据类型 -->
             <FormItem :label="$t('BasicProduct.funcBox.titleName.DataType')" prop="formatType" style="width: 575px;" class="dataItem">
                <Select :placeholder="$t('selectPlaceholder')" class="input-div" v-model="formData.formatType" @on-select="setSelectValType($event,'formatType')"  :disabled="isGener">
                    <Option v-for="item in formatTypeList" :value="item.id+''" :key="item.id">{{item.val}}</Option>
                </Select>
            </FormItem>

        
            <!-- 名称 -->
            <FormItem  :label="$t('BasicProduct.funcBox.titleName.LanguageKey')" prop="LanguageKey" style="width: 575px">

                <SearchSelectPage  refName="refLanguageKey" listName="dealersList"  :showPage="true" ref="refLanguageKey" :selectUrlQuery="{pageId:pageID}" :url="pagesIdListUrl"  labelName='wordCode'  isMultiple='2'  valName='id' :labelNameNew="local=='zh-CN'?'simpleChinese':'englishText'" keyword="wordCode" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectValNamePage($event)"></SearchSelectPage>

            </FormItem>

            <!-- 标识符 -->
            <!-- <div  v-show="formData.formatType!=3 && formData.formatType!=2">
                <FormItem
                  :label="$t('BasicProduct.funcBox.titleName.Identifier')" 
                  prop="keyId" 
                  :class="'ivu-form-item-required'" 
                  :rules="(formData.formatType!=3 && formData.formatType!=2) ? ruleCustom['keyId']: ruleCustom.noRequired"
                  style="width: 575px">
                    <Input type="text" v-model="formData.keyId" :placeholder="$t('inputPlaceholder')"></Input>
                </FormItem>
            </div> -->
            
            <FormItem  :label="$t('BasicProduct.funcBox.titleName.Identifier')" prop="keyId" :class="'ivu-form-item-required'" style="width: 575px">
                <Input type="text" v-model="formData.keyId" :placeholder="$t('inputPlaceholder')"></Input>
            </FormItem>



           


             <!-- 数值型 -->
             <div v-show="formData.formatType==1 || formData.formatType==15 || formData.formatType==16">
                    <FormItem :label="$t('BasicProduct.funcBox.titleName.ValueRange')" class="ivu-form-item-required" 
                        style="width: 575px">
                        <div class="flexC">
                            <FormItem  prop="Min" key="Min" :rules="(formData.formatType==1 || formData.formatType==15 || formData.formatType==16) ? ruleCustom.Min: ruleCustom.noRequired">
                                <Input type="number" v-model="formData.Min" :placeholder="$t('BasicProduct.funcBox.titleName.Min')"></Input>
                            </FormItem>
                            <div style="margin:0 20px ;">-</div>
                            <FormItem  prop="Max" key="Max"  :rules="(formData.formatType==1 || formData.formatType==15 || formData.formatType==16) ? ruleCustom.Max: ruleCustom.noRequired">
                                <Input type="number" v-model="formData.Max" :placeholder="$t('BasicProduct.funcBox.titleName.Max')"></Input>
                            </FormItem>
                        </div>
                    </FormItem>
                    <FormItem :label="$t('BasicProduct.funcBox.titleName.Unit')" prop="Unit LanguageKey" key="Unit LanguageKey" :rules="(formData.formatType==1 || formData.formatType==15 || formData.formatType==16) ? ruleCustom['Unit LanguageKey']: ruleCustom.noRequired" style="width: 575px">
                    
                        <SearchSelectPage  refName="refUnitLanguageKey" listName="dealersList"  :showPage="true" ref="refUnitLanguageKey" :selectUrlQuery="{pageId:pageID}" :url="pagesIdListUrl"  labelName='wordCode'  isMultiple='2'  valName='id' :labelNameNew="local=='zh-CN'?'simpleChinese':'englishText'" keyword="wordCode" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectValPage($event,'Unit LanguageKey')"></SearchSelectPage>

                    </FormItem>
                    
                    <FormItem :label="$t('BasicProduct.funcBox.titleName.Decimals')" prop="Decimals" key="Decimals"  :rules="(formData.formatType==1 || formData.formatType==15 || formData.formatType==16) ? ruleCustom.Decimals: ruleCustom.noRequired" style="width: 575px">
                        <Input type="number" v-model="formData.Decimals" :placeholder="$t('inputPlaceholder')"></Input>
                    </FormItem>
                    <FormItem :label="$t('BasicProduct.funcBox.titleName.Step')"  prop="Step" key="Step"  :rules="(formData.formatType==1 || formData.formatType==15 || formData.formatType==16) ? ruleCustom.Step: ruleCustom.noRequired" style="width: 575px">
                        <Input type="number" v-model="formData.Step" :placeholder="$t('inputPlaceholder')"></Input>
                    </FormItem>
    
             </div>

             <!--Boolean  -->
             <div v-show="formData.formatType == 3">
                                  
                   <FormItem label="false" prop="false LanguageKey" key="false LanguageKey"  :rules="(formData.formatType==3) ? ruleCustom['false LanguageKey']: ruleCustom.noRequired" style="width: 575px">
                   
                        <SearchSelectPage  refName="reffalseLanguageKey'" listName="dealersList"  :showPage="true" ref="reffalseLanguageKey" :selectUrlQuery="{pageId:pageID}" :url="pagesIdListUrl"  labelName='wordCode'  isMultiple='2'  valName='id' :labelNameNew="local=='zh-CN'?'simpleChinese':'englishText'" keyword="wordCode" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectValPage($event,'false LanguageKey')"></SearchSelectPage>

                   </FormItem>
                   
                   <FormItem label='true' prop="true LanguageKey" key="true LanguageKey" :rules="(formData.formatType==3) ? ruleCustom['true LanguageKey']: ruleCustom.noRequired"  style="width: 575px">

                        <SearchSelectPage  refName="reftrueLanguageKey'" listName="dealersList"  :showPage="true" ref="reftrueLanguageKey" :selectUrlQuery="{pageId:pageID}" :url="pagesIdListUrl"  labelName='wordCode'  isMultiple='2'  valName='id' :labelNameNew="local=='zh-CN'?'simpleChinese':'englishText'" keyword="wordCode" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectValPage($event,'true LanguageKey')"></SearchSelectPage>

                    
                   </FormItem>
                
             </div>

             <!-- string -->
             <div v-show="formData.formatType == 4">
                   <FormItem :label="$t('BasicProduct.funcBox.titleName.Bytes')" prop="Bytes" key="Bytes"  :rules="(formData.formatType==4) ? ruleCustom['Bytes']: ruleCustom.noRequired"
                       style="width: 575px">
                       <Input type="number" v-model.trim="formData.Bytes" :placeholder="$t('productManage.functionModel.inputPlaceholder.string')"  :disabled="isGener"></Input>
   
                   </FormItem>
            </div>

            <!-- date -->
            <div v-show="formData.formatType == 6">
             
                     <FormItem :label="$t('BasicProduct.funcBox.titleName.time')" prop="time" key="time" :rules="(formData.formatType==6) ? ruleCustom['time']: ruleCustom.noRequired" style="width: 575px" >
                        <Select :placeholder="$t('selectPlaceholder')"  class="input-div" v-model="formData.time">
                            <Option v-for="item in timeList2" :value="item.id+''" :key="item.id">{{item.val}}</Option>
                        </Select>
                    </FormItem>
        
                    <FormItem :label="$t('BasicProduct.funcBox.titleName.timeFormate')" prop="formate" key="formate" :rules="(formData.formatType==6) ? ruleCustom['formate']: ruleCustom.noRequired" style="width: 575px">
                        <Select :placeholder="$t('selectPlaceholder')"  class="input-div" v-model="formData.formate">
                            <Option v-for="item in timeFormateList" :value="item.id+''" :key="item.id">{{item.val}}</Option>
                        </Select>
                    </FormItem>
        
        
                     <FormItem :label="$t('BasicProduct.funcBox.titleName.Max')" prop="maxTime" key="maxTime" :rules="(formData.formatType==6) ? ruleCustom['maxTime']: ruleCustom.noRequired" style="width: 575px" >
                         <Input type="text"  v-model.trim="formData.maxTime"  :placeholder="$t(`inputPlaceholder`)"></Input>
                    </FormItem>
        
                     <FormItem :label="$t('BasicProduct.funcBox.titleName.Min')" prop="minTime" key="minTime" :rules="(formData.formatType==6) ? ruleCustom['minTime']: ruleCustom.noRequired" style="width: 575px" >
                       <Input type="text"  v-model.trim="formData.minTime"  :placeholder="$t(`inputPlaceholder`)"></Input>
                    </FormItem>
             </div>
    
             <!-- enum -->
             <div v-show="formData.formatType == 2">
                <div  style="max-height:200px;overflow-y:auto">
                       <div v-for="(item, index) in formData.enumItems" :key="index">
                           <div class="flexBC" v-show="item.status">
                           
                               <!--key5:'wordId',  key1:'Name-CN', key4:"Name-EN",key2:'Code',key3:'LanguageKey',ke6:'pageId_wordId' -->
       
                               <FormItem :label="$t('BasicProduct.funcBox.titleName.Enumeration')+index" class="ivu-form-item-required"
                                   style="width: 575px" >
                                  
                                   <div class="flexC">
                                       <FormItem  :prop="'enumItems.' + index + '.LanguageKey'" :key="'enumItems.' + index + '.LanguageKey'"  :rules="(formData.formatType==2) ? {required: item.status===1?true:false, message: $t('required'), trigger: 'change'}: ruleCustom.noRequired"  style="width:400px">

                                           <SearchSelectPage  :refName="'select'+index" listName="dealersList"  :showPage="true" :ref="'select'+index" :selectUrlQuery="{pageId:pageID}" :url="pagesIdListUrl"  labelName='wordCode'  isMultiple='2'  valName='id' :labelNameNew="local=='zh-CN'?'simpleChinese':'englishText'" keyword="wordCode" :labelInValue="true" :placeholderText="$t('selectPlaceholder')"  @setSelected="setSelectValPage($event,'Enumeration',item.index)"></SearchSelectPage>

                                       </FormItem>
                                       <div style="margin:0 20px ;">-</div>
                                       <FormItem   :prop="'enumItems.' + index + '.Code'" :key="'enumItems.' + index + '.Code'"  :rules="(formData.formatType==2) ? {required: item.status===1?true:false, message: $t('required'), trigger: 'blur'}: ruleCustom.noRequired"  style="width:100px">
                                           <Input type="text" v-model="item.Code" placeholder="Code"></Input>
                                       </FormItem>
                                   </div>
       
                               </FormItem>
                       
                               <Button style="margin-left:20px;flex-shrink:0"   v-if="item.status" :disabled="enumDelDisabled" type="error" @click="handleRemove(index)">{{$t("delete")}}</Button>
                             
                           </div>
                            
                       </div>
                    </div>
                    <FormItem>
                        <Row>
                            <Col span="12">
                                <Button type="dashed" long @click="handleAdd" icon="md-add">{{$t("add")}}</Button>
                            </Col>
                        </Row>
                    </FormItem>
             </div>

             <!-- array -->
             <div v-show="formData.formatType == 17 ">
                <FormItem :label="$t('BasicProduct.funcBox.titleName.ElementType')" prop="elementType" style="width: 500px;" class="dataItem">
        
                    <RadioGroup v-model="formData.elementType">
                        <Radio v-for="item in elementTypeList" :label="item.id+''" :key="item.id">{{ item.val }}</Radio>
                    </RadioGroup>
            
                </FormItem>
                
                <div  style="max-height:200px;overflow-y:auto">
                   

                     <template v-if="formData.elementType==13">
                           <FormItem label="struct">
                               <div style="max-height:200px;overflow-y:auto">
                                   <div class="flexC" style="margin-bottom:10px" v-for="(item,index) in formData.arrayItems" :key="index">
                                       <div class='paramsContainer' style="width:220px;">
                                           <div class='itemContainer one-txt-cut' :title="item.LanguageKey">
                                               {{formatTypeObj[item.formatType]}}: {{item.LanguageKey}}
                                           </div>
                                       </div>
           
                                       <div class='operate' style="margin-left:50px ;">
                                           <div class='operating flexC' >
                                               <a @click="editTypeDiscription(item,index)" >{{isGener?$t('detail'):$t('edit')}}</a>
                                               <span style="margin:0 5px ;"> | </span>
                                               <a @click="delTypeDiscription(item,index)" :disabled="isGener" style="color:red;">{{$t('delete')}}</a>
                                           </div>
                                       </div>
                                   </div>
                               </div>
                               <div type="text" style="color: #2d8cf0;cursor: pointer;"  @click="showIndentyName('arrayItems')">
                                  {{$t('BasicProduct.addParams')}}
                               </div>
                           </FormItem>
                   
                        </template>
                </div>
             </div>

             
            
             <FormItem v-if="isGener">
                <Button type="primary" @click="cancel">{{$t("cancel")}}</Button>
            </FormItem>

            <FormItem v-else>
                <Button type="primary"  :disabled="type==3" @click="handleSubmit('formData')">{{$t('save')}}</Button>
                <!-- <Button @click="resetForm" style="margin-left: 8px">{{$t('reset')}}</Button> -->
                <Button @click="cancel" style="margin-left: 8px">{{$t('cancel')}}</Button>
            </FormItem>
        </Form>

        </Modal>
        <StructType  :showSetModel.sync="structTypeNameBox.showSetModelStruct" :isGener="isGener" :pageId="pageId"  :type="structTypeNameBox.type" DataType='13' :isShowAarray="true" :editFormData="structTypeNameBox.editFormData" :fn="structTypeNameBox.callbackFn"></StructType>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showSetModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import { mapState } from 'vuex'
// import SearchSelectPage from '@/views/common/selectListPage.vue';  //20220415
import SearchSelectPage from '@/views/common/selectListRecycle.vue';  //20220415
import StructType from './structTypeSan.vue'



    export default {
        name: 'ModelStruct',
        props: {
            showSetModel: Boolean,
            fn:Function,
            type:Number,
            pageId:[Number, String],
            editFormData:Object,
            DataType:String,
            // languageKey:Object,
            // initdata:Object,
            isGener:{
                type:Boolean,
                default:false
            }
        },
        components:{
            SearchSelectPage,
            StructType
        },
        data() {
            return {   
                pagesIdListUrl: this.config.urlArray.pagesLangDictionaryList,//对应pageId的词条列表
                disabled: false,//禁用确定按钮
                formData: {
                   'Name-CN':"",
                   'Name-EN':"",
                   LanguageKey:"",
                   wordId:"",
                  "pageId_wordCode":"",
                  formatType:'16',
                   Min:'',
                   Max:'',
                   Decimals:'',
                   Step:'',
                  'false LanguageKey':'',
                  "false wordId":"",
                  "false pageId_wordCode":"",
                  "false Name-CN":"",
                  "false Name-EN":"",
                  'true LanguageKey':'',
                  "true wordId":"",
                  "true pageId_wordCode":"",
                  "true Name-CN":"",
                  "true Name-EN":"",
                  Bytes:'',
                  enumItems:[
                    {Code:'',LanguageKey : '','wordId':'','pageId_wordCode':'',index: 1,status: 1}
                  ],
                
                  maxTime:'',
                  minTime:'',
                  time:'',
                  formate:'',
                   UnitWordId:'',
                  'Unit wordId':'',
                  'Unit Name-CN':'',
                  'Unit Name-EN':'',
                  'Unit pageId_wordCode':'',
                  'Unit LanguageKey':'',
                   keyId:'',
                   elementType:"16",
                   arrayItems:[],
                },
                wordList:[],
                wordListLoading:false,
                formatTypeList: [
                    {id:16,val:'int32(整数型)'},
                    {id:15,val:'float(单精度浮点型)'},
                    {id: 1,val:'double(双精度浮点型)'},
                    {id: 2,val:'enum(枚举型)'},
                    {id: 3,val:'bool(布尔型)'},
                    {id: 4,val:'text(字符串)'},
                    {id: 6,val:'date(时间型)'},
                    {id: 17,val:'array(数组型)'},
                ],
                enumIndex:1,
                enumInitData:{Code:'',LanguageKey : '','wordId':'','pageId_wordCode':'',index: 1,status: 1},
                enumDelDisabled:true,
                pageID:'',
                elementTypeList: [
                    { id: 16, val: 'int32' },
                    { id: 15, val: 'float' },
                    { id: 1, val: 'double' },
                    { id: 4, val: 'text' },
                    // { id: 13, val: 'struct' },
                ],
                structTypeNameBox:{
                    showSetModelStruct:false,
                    type:1,
                    key:{},
                    editFormData:{},
                    callbackFn:(e)=>{}
                }
               
               
            
            }
        },
        computed:{
            ...mapState(['local','selectId','wordListAll','wordListByPageId','timeFormateList','pageIdStore','formatTypeObj']),
             ruleCustom(){
                return {//验证
                    LanguageKey: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    keyId: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                        {type: 'string', pattern: /^[0-9a-zA-Z_]{1,50}$/, message: this.$t('ruleCustom.wordCode'), trigger:'blur'},
                    ],
                    formatType: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    Max: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    Min: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    Decimals: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    Step: [
                        {required: true, message: this.$t('required'),trigger: 'blur' },
                    ],
                    'Unit LanguageKey':[
                        {required: false, message: this.$t('required'),trigger: 'change' },
                    ],
                    'false LanguageKey':[
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    'true LanguageKey':[
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    Bytes:[
                        {required: true, message: this.$t('required'),trigger: 'blur' }
                    ],
                    time: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    formate: [
                        {required: true, message: this.$t('required'),trigger: 'change' },
                    ],
                    maxTime: [
                        {required: false, message: this.$t('required'),trigger: 'blur' },
                    ],
                    minTime: [
                        {required: false, message: this.$t('required'),trigger: 'blur' },
                    ],
                    noRequired: [{ required: false }]
                }
             },
             timeList2(){
                return [
                    {id: '1',val:this.$t('selectList.timeUnit.msceond')},
                    {id: '2',val:this.$t('selectList.timeUnit.second')},
                    {id: '3',val:this.$t('selectList.timeUnit.minute')},
                    {id: '4',val:this.$t('selectList.timeUnit.hour')},
                ]
            },

        },
        created(){
            this.pageID = this.pageId || this.pageIdStore || ''
           
        },
        methods: {
            showIndentyName(){
                if(this.isGener){
                     return
                 }
                 this.structTypeNameBox.showSetModelStruct= true;
                 this.structTypeNameBox.editFormData = {IndentyName:{},allArr:this.formData.arrayItems}
                 this.structTypeNameBox.type = 1
                 console.log('this.formData.arrayItems',this.formData)


                this.structTypeNameBox.callbackFn = (arr,text) => {//回调处理
                    console.log('addarr',arr)
                    console.log('text',text)
                    //重新载入
                    this.structTypeNameBox.showSetModelStruct= false;
                    console.log('this.formData.arrayItems',this.formData.arrayItems)
                    this.formData.arrayItems.push(arr)
                    if(this.formData.arrayItems.length){

                        this.formData.arrayItems = this.formData.arrayItems.map(item=>{
                            if(item.index) delete item.index
                            if(item.status) delete item.status
                            return item
                        })
                    }
                    console.log('this.formData.arrayItems',this.formData.arrayItems)

                }

            },
            delTypeDiscription(item,index){//删除数据类型详细
               this.formData.arrayItems.splice(index,1)
            },
            editTypeDiscription(item,index){//编辑数据类型详细
                 this.structTypeNameBox.type = 2
                 this.structTypeNameBox.editFormData = {IndentyName:item,allArr:this.formData.arrayItems}

                  this.structTypeNameBox.showSetModelStruct= true;
                  this.structTypeNameBox.callbackFn = (arr,text) => {//回调处理
                    //重新载入
                    console.log('editarreditarr',arr)
                    this.structTypeNameBox.showSetModelStruct= false;
                    this.formData.arrayItems[index] = {...arr}
                    console.log('this.formData.arrayItems',this.formData.arrayItems)

                }

            },
            setSelectValType(e){//类型选择
                if(e){
                    let type =  e.value+'';
                    this.resetRule(type)
                }
            },
            setSelectValNamePage(selItem){//最外层语言标识选择
                if(selItem){
                    this.formData['wordId'] = selItem.id+'';
                    this.formData['LanguageKey'] = selItem.wordCode;
                    this.formData['pageId_wordCode'] = this.pageID+'_'+selItem.wordCode+'';
                    this.formData['Name-CN'] = selItem.simpleChinese;
                    this.formData['Name-EN']= selItem.englishText
                }else{
                    this.formData['wordId'] = '';
                    this.formData['LanguageKey'] = '';
                    this.formData['pageId_wordCode'] = '';
                    this.formData['Name-CN'] = '';
                    this.formData['Name-EN']= ''
                }
            },
            setSelectValPage(selItem,key,index){

                let obj = {'wordId':'','false wordId':'false ','true wordId':'true ','false LanguageKey':'false ','true LanguageKey':'true ','Unit LanguageKey':'Unit '}
                
                if(selItem){
                    this.formData[key] = selItem.id+'';

                    if(key in obj){
                        this.formData[obj[key]+'LanguageKey'] = selItem.wordCode;
                        this.formData[obj[key]+'pageId_wordCode'] = this.pageID+'_'+selItem.wordCode+'' ;
                        this.formData[obj[key]+'Name-CN'] = selItem.simpleChinese;
                        this.formData[obj[key]+'Name-EN'] = selItem.englishText;
                        this.formData[obj[key]+'wordId'] =  selItem.id+'';
                    }

                    if(key=='Enumeration'){
                        (this.formData.enumItems[index-1])['wordId'] = selItem.id+'';
                        (this.formData.enumItems[index-1])['LanguageKey'] = selItem.wordCode;
                        (this.formData.enumItems[index-1])['pageId_wordCode'] = this.pageID+'_'+selItem.wordCode+'' ;
                        (this.formData.enumItems[index-1])['Name-CN'] = selItem.simpleChinese;
                        (this.formData.enumItems[index-1])['Name-EN'] = selItem.englishText;
          
                       
                    }

                }else{
                    this.formData[key] = '';
                    if(key in obj){
                        this.formData[obj[key]+'LanguageKey'] = '';
                        this.formData[obj[key]+'pageId_wordCode'] = '';
                        this.formData[obj[key]+'Name-CN'] = '';
                        this.formData[obj[key]+'Name-EN'] = '';
                        this.formData[obj[key]+'wordId'] = '';
                    }
                    if(key=='Enumeration'){

                        (this.formData.enumItems[index-1])['wordId'] = '';
                        (this.formData.enumItems[index-1])['LanguageKey'] = '';
                        (this.formData.enumItems[index-1])['pageId_wordCode'] = '';
                        (this.formData.enumItems[index-1])['Name-CN'] = '';
                        (this.formData.enumItems[index-1])['Name-EN'] = '';
                        
                    }
                }

            },
            
            clearSelectVal(key,index=-1){
       
                this.formData[key] = '';

                let obj = {'wordId':'','false wordId':'false ','true wordId':'true ','false LanguageKey':'false ','true LanguageKey':'true ','Unit LanguageKey':'Unit '}
                
                if(key in obj){
                    this.formData[obj[key]+'LanguageKey'] = '';
                    this.formData[obj[key]+'pageId_wordCode'] = '';
                    this.formData[obj[key]+'Name-CN'] = '';
                    this.formData[obj[key]+'Name-EN'] = '';
                    
                }

                if(key=='Enumeration'){
                    // let indexFlag = index-1
                    (this.formData.enumItems[index-1])['wordId'] = '';
                    (this.formData.enumItems[index-1])['LanguageKey'] = '';
                    (this.formData.enumItems[index-1])['pageId_wordCode'] = '';
                    (this.formData.enumItems[index-1])['Name-CN'] = '';
                    (this.formData.enumItems[index-1])['Name-EN'] = '';
                    
                }





            },
            handleAdd () {
                this.enumIndex++;
                let obj = {...this.enumInitData,index: this.enumIndex}
                this.formData.enumItems.push(obj)
                let arr = this.formData.enumItems.filter(item=>item.status)
                if(arr.length>1) this.enumDelDisabled = false
                let len = this.formData.enumItems.length-1
                this.$nextTick(()=>{
                    this.$refs['select'+len][0].getData()
                })
            },
            handleRemove (index) {
                this.formData.enumItems[index].status = 0;
                this.$nextTick(()=>{
                    this.$refs['select'+index][0].clearVal()
                })
                let arr = this.formData.enumItems.filter(item=>item.status)
                if(arr.length<2) this.enumDelDisabled = true
                this.$forceUpdate()
            },
            handleSubmit (name){
                if(this.isGener){
                    return
                }
      
                this.$refs[name].validate((valid) => {


                    if (valid) {
    
                           // enum类型判断cide是否重复
                        if(this.formData.enumItems){
                            const arr1 = this.formData.enumItems.filter((item)=>item.status).map((item1)=>item1.Code)
                            const arr2 = new Set(arr1)
                            if(arr2.size != arr1.length){
                                this.$Message.error('code重复');
                                return
                            }
                        }
        
                        // 最大值必须大于最小值
                        if(this.formData.Min && this.formData.Min>=this.formData.Max){
                            this.$Message.error('最大值必须大于最小值');
                            return
                        }

                        let obj = Object.fromEntries(
                           Object.entries(this.formData).filter(([key, value]) => value !== '')
                        );

                        let type = this.formData.formatType +''

                        if(type !=2){
                            delete obj.enumItems
                        }

                        if(type==2){
                            delete obj.Enumeration
                            obj.enumItems = this.formData.enumItems.filter((item)=>{
                               return  item.status==1
                            }).map(item=>{
                                delete item.index
                                delete item.status
                                return item
                            })
                        }

                        if(obj.elementType=='13'){
                            obj.arrayItems = this.formData.arrayItems
                        }
                        
            
                        // console.log('obj',obj)
                        // console.log('this.formData.arrayItems',this.formData.arrayItems)
                        // console.log('common.deepCloneobj',common.deepClone(obj))
                        // console.log('common.deepCloneWithRecursion',_.cloneDeep(obj))
                        // console.log('common.deepCloneWithRecursion',common.deepCloneWithRecursion({...obj}))

                      
                        this.fn(_.cloneDeep(obj),type)

                        setTimeout(()=>{
                            this.resetForm()
                        },0)



                        
                    }
                })
            },
        
            async openOrClose(value) {
                if(value === true) {

                    
                    this.enumIndex = 1
                    if(this.type==2){
                     
                        this.formData.formatType = this.editFormData.IndentyName.formatType

                        for (let key in this.editFormData.IndentyName) {
                            if (this.formData.hasOwnProperty(key) &&( this.editFormData.IndentyName[key] || this.editFormData.IndentyName[key]===0)) {
                                this.formData[key] = this.editFormData.IndentyName[key]
                            }
                        }

                        this.setDefaultSelectPage()

                        // 外层name赋值
                        // this.setEnumDefault()

                        // console.log('this.formData',this.formData)
                    }else{

                        this.formData.formatType = '16'
                        this.formData.enumItems = [{Code:'',LanguageKey : '','wordId':'','pageId_wordCode':'',index: 1,status: 1}]
                        this.$refs.refLanguageKey.getData()
                        this.$refs.refUnitLanguageKey.getData()
                    }
                } else{
                    // this.resetForm()
                }
            },
            cancel() {//对话框关闭
                this.$emit('update:showSetModel',false);
                this.resetForm()
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.resetRef()
                setTimeout(() => {
                    Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
                    this.formData.formatType = '16'
                    this.formData.enumItems = [{Code:'',LanguageKey : '','wordId':'','pageId_wordCode':'',index: 1,status: 1}]
                    this.formData.arrayItems = []
                    this.formData.elementType ="16"
                }, 0);
                this.disabled = false;//恢复提交按钮为激活状态
            },
            resetRef(){
                let refObj = {'1':'refUnitLanguageKey','15':'refUnitLanguageKey','16':'refUnitLanguageKey'}
                let booleanArr = ['reffalseLanguageKey','reftrueLanguageKey']
                let refArr = [ ...Array.from(new Set(Object.values(refObj))),...booleanArr]
                if(this.$refs.refLanguageKey){

                    this.$refs.refLanguageKey.clearVal()
                }
                for(let i=0;i<refArr.length;i++){
                    if(this.$refs[refArr[i]]){
                        this.$nextTick(()=>{
                            if(Array.isArray(this.$refs[refArr[i]])){
                                this.$refs[refArr[i]][0].clearVal()
                            }else{
                                this.$refs[refArr[i]].clearVal()
                            }
                        })
                    }
                }

                for(let i=0;i<this.formData.enumItems.length;i++){
                    // console.log("this.$refs['select'+i]",this.$refs['select'+i])
                    if(this.$refs['select'+i]){
                        this.$nextTick(()=>{
                            if(Array.isArray(this.$refs['select'+i])){
                                this.$refs['select'+i][0].clearVal()
                            }else{
                                this.$refs['select'+i].clearVal()
                            }
                        })
                    }
                }

            },
            resetRule(type){//切换类型时清除验证规则

                this.selectPageChange(type)
                this.$refs.formData.resetFields();//重置表单
                this.formData.formatType = type

                if(this.type==1){
                    this.enumIndex = 1
                    this.enumDelDisabled = true
                    this.formData.enumItems = [{Code:'',LanguageKey : '','wordId':'','pageId_wordCode':'',index: 1,status: 1}]
                }else{
                   this.setEnumDefault()
                }
            },
            selectPageChange(type){
                let refObj = {'1':'refUnitLanguageKey','15':'refUnitLanguageKey','16':'refUnitLanguageKey'}

                this.$refs.refLanguageKey.clearVal()
                this.$refs.refLanguageKey.getData()
               
                 this.resetRef()

                if(Object.keys(refObj).includes(type)){

                    this.$nextTick(()=>{
                        if(Array.isArray(this.$refs[refObj[type]])){
                            this.$refs[refObj[type]][0].getData()
                        }else{
                            this.$refs[refObj[type]].getData()
                        }
                    })
                }

                if(type==3){
                    this.$nextTick(()=>{
                        this.$refs.reffalseLanguageKey.getData()
                        this.$refs.reftrueLanguageKey.getData()
                   })
                }

                if(type==2){
                    this.enumIndex = 1
                    this.enumDelDisabled = true
                    this.formData.enumItems = [{Code:'',LanguageKey : '','wordId':'','pageId_wordCode':'',index: 1,status: 1}]
                    this.$nextTick(()=>{
                        if(Array.isArray(this.$refs.select0)){
                            this.$refs.select0[0].getData()
                        }else{
                            this.$refs.select0.getData()
                        }
                   })
                }

            },
            setDefaultSelectPage(){
                // console.log('this.formData',this.formData)
                this.$nextTick(()=>{
                    // this.$refs.refwordId.setDefVal(this.formData.wordId)
                    this.$refs.refLanguageKey.setDefVal({
                        id:this.formData.wordId,
                        wordCode:this.formData.LanguageKey
                    })
                })
                if((this.formData.formatType==1 || this.formData.formatType==15 ||this.formData.formatType==16)){
                    this.$nextTick(()=>{
                         // this.$refs.refUnitWordId.setDefVal(this.formData.UnitWordId)
                        this.$refs.refUnitLanguageKey.setDefVal({
                            id:this.formData.UnitWordId || this.formData['Unit wordId'],
                            wordCode:this.formData['Unit LanguageKey']
                        })
                    })
                }

                if(this.formData.formatType==3){
                    this.$nextTick(()=>{
                        this.$refs.reffalseLanguageKey.setDefVal({
                            id:this.formData['false wordId'],
                            wordCode:this.formData['false LanguageKey']
                        })
                        this.$refs.reftrueLanguageKey.setDefVal({
                            id:this.formData['true wordId'],
                            wordCode:this.formData['true LanguageKey']
                        })
                        
                    })
                }
                
                if(this.formData.formatType==2){
                    this.setEnumDefault()
                    
                    if(this.formData.enumItems.length && this.formData.formatType==2){
                        
                        for(let i=0;i<this.formData.enumItems.length;i++){
                            let param = {
                                id:this.formData.enumItems[i].wordId,
                                wordCode:this.formData.enumItems[i].LanguageKey
                            }
        
                            this.$nextTick(()=>{
                                this.$refs['select'+i][0].setDefVal(param)
                            })
                        }

                    }
                }
                
            },
            setEnumDefault(){
                if(this.formData.formatType==2){

                    let arr = common.deepClone( [...this.editFormData.IndentyName.enumItems])
                    arr.map((item,index)=>{
                        item.status = 1
                        item.index = index+1
                    
                        return item
                    })
                    this.formData.enumItems = [...arr]
                    this.enumIndex = arr.length
                    if(this.formData.enumItems.length>1) this.enumDelDisabled = false


                    if(this.formData.enumItems.length && this.formData.formatType==2){
                        
                        let flag = 1
                        this.formData.enumItems.map((item)=>{
                            if(!item.LanguageKey){
                                flag=0
                            }
                        })
                        if(flag==0){
                            for(let i=0;i<this.editFormData.IndentyName.enumItems.length;i++){
                                for(let j=0;j<this.formData.enumItems.length;j++){
                                    if(this.editFormData.IndentyName.enumItems[i].pageId_wordCode==this.formData.enumItems[j].pageId_wordCode && !this.formData.enumItems[j].LanguageKey){
                                        this.formData.enumItems[j].LanguageKey = this.editFormData.IndentyName.enumItems[i].LanguageKey
                                        this.formData.enumItems[j].Code = this.editFormData.IndentyName.enumItems[i].Code
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</script>

<style lang="less" scoped>
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;

        .ivu-select-dropdown {
            max-width: 380px;
        }
    }

   
}
/deep/ .ivu-input-number{
    width: 100% !important;
}
/deep/ .ivu-input[disabled]{
    background-color: #ffffff;
    color: #515a6e;
}



</style>
<!-- <style>
.ivu-select-dropdown{
  max-width: 200px !important;
}
</style> -->

